


































































/* Created- 22 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";

import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig, ButtonStatus, ButtonType } from "../../Models/Buttons";
import { eParticaAction, ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import { IArticle, Article, ArticleImage } from "../../Models/ArticleModels/article";
import { IParticaStoreService } from "../../BusinessServices/particastore";
import ParticaAccountBase from "../Base/ParticaAccountBase.vue";
import SimpleArticleView from "../../Ui-Components/Article/SimpleView/SimpleArticleView.vue";
import ParticaArticleEdit from "../../Ui-Components/Article/Edit/ParticaArticleEdit.vue";
import ArticleTable from "../../Ui-Components/Article/Table/ArticleTable.vue";
import { ArticleModelArticleType, WordpressPluginDTO, WordpressPublishDTO } from "../../Generated/ParticaAPI";
import { IWordpressPluginService } from "../../BusinessServices/wpplugin";
import PushWordpress from "../../Ui-Components/Article/Wordpress/PushWordpress.vue";
import PushSelectedWordpress from "../../Ui-Components/Article/Wordpress/PushSelectedWordpress.vue";

@Component(
	{
		name: "PushToWordpress",
		components: {
			SimpleArticleView,
			ParticaCard,
			ParticaView,
			ParticaArticlePreview,
			ParticaRowContainer,
			ParticaArticleEdit,
			ArticleTable,
			PushWordpress,
			PushSelectedWordpress
		}
	})
export default class PushToWordpress extends ParticaAccountBase {
	@Prop() private id: number;

	private selectedArticles: IArticle[];
	private store: IParticaStoreService;
	private wpservice: IWordpressPluginService;
	private data: IArticle[] = [];
	private showpreviewarticle: boolean = false;
	private showpush: boolean = false;
	private currentarticle: IArticle = new Article() as IArticle;
	private plugins: WordpressPluginDTO[] = [];
	private showselectedpush: boolean = false;

	private buttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.ARTICLE_SAVE, label: "Save Article", status: ButtonStatus.Disabled, type: ButtonType.OK } as ButtonConfig,
	];
	private pushbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.PUSH_WORDPRESS, label: "Push to Wordpress", status: ButtonStatus.Enabled, type: ButtonType.OK } as ButtonConfig,
	];
	private pushselectedbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.PUSH_SELECTED_TO_WORDPRESS, label: "Push to Wordpress", status: ButtonStatus.Enabled, type: ButtonType.OK } as ButtonConfig,
	];
	private selectedbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.PUSH_SELECTED_WORDPRESS, label: "Push Selected to Wordpress", status: ButtonStatus.Disabled, type: ButtonType.OK } as ButtonConfig,
	];



	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.RIGHT_MOUSE_CLICK: {
					const article: IArticle = event.item;
					switch (article.articleType) {
						case ArticleModelArticleType.Purchased: {
							this.currentarticle = await this.store.getPurchasedArticle(event.item.articleId);
							break;
						}
						case ArticleModelArticleType.Curated: {
							this.currentarticle = await this.store.getStreamArticle(event.item.articleId);
							break;
						}
					}
					this.showpreviewarticle = true;
					break;
				}
				case eParticaAction.LEFT_MOUSE_CLICK: {
					this.currentarticle = event.item;
					this.showpush = true;
					break;
				}
				case eParticaAction.PUSH_WORDPRESS: {
					const pushdata: WordpressPublishDTO = new WordpressPublishDTO();
					pushdata.articleId = this.currentarticle.id;
					pushdata.wordpressPluginId = event.item.id;
					await this.wpservice.pushArticle(pushdata);
					this.ShowSnackbar(`${this.currentarticle.title} pushed to ${event.item.url}`);
					this.showpush = false;
					break;
				}
				case eParticaAction.PUSH_SELECTED_WORDPRESS: {
					this.selectedArticles = event.item as IArticle[];
					this.showselectedpush = true;
					break;
				}
				case eParticaAction.PUSH_SELECTED_TO_WORDPRESS: {
					const pushdata: WordpressPublishDTO[] = [];
					for (const article of this.selectedArticles) {
						const data: WordpressPublishDTO = new WordpressPublishDTO();
						data.articleId = article.id;
						data.wordpressPluginId = event.item.id;
						pushdata.push(data);
					}
					await this.wpservice.pushArticles(pushdata);
					this.ShowSnackbar(`${this.selectedArticles.length} articles pushed to ${event.item.url}`);
					this.showselectedpush = false;
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Purchased Articles";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.store = this.particaServices.getParticaStoreService();
			this.wpservice = this.particaServices.getWordpressPluginService();
			await this.getAccountNav(this.id);
			this.plugins = await this.wpservice.get(this.id);
			this.data = await this.store.getStoreArticles(this.id);
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}
}
